import type { BeneficiaryBankAccount } from '@/lib/api/accounting';

export const PROJECT_WORKSPACE_SECTIONS = new Set(['overview']);

export const COUNTERPARTY_KEY_RE = /^(employee|client|company)-(\d+)$/;

export function projectBeneficiaryPath(projectId: number, beneficiaryKey: string): string {
  return `/projects/${projectId}/beneficiary/${encodeURIComponent(beneficiaryKey)}`;
}

export function employeeProfilePath(employeeId: number): string {
  return `/employees/${employeeId}`;
}

export function resolveBeneficiaryLabel(
  key: string,
  apiLabel: string | undefined,
  lookup: Map<string, string>,
): string {
  if (key && lookup.has(key)) return lookup.get(key)!;
  if (apiLabel && apiLabel !== key && !COUNTERPARTY_KEY_RE.test(apiLabel)) return apiLabel;
  return apiLabel || key || '—';
}

export function beneficiaryTypeFa(type: 'employee' | 'client' | 'company' | string): string {
  const map: Record<string, string> = {
    employee: 'کارمند',
    client: 'مشتری',
    company: 'شرکت',
  };
  return map[type] || 'طرف حساب';
}

export function parseCounterpartyKey(key: string): { type: string; id: number } | null {
  const m = key.match(COUNTERPARTY_KEY_RE);
  if (!m) return null;
  return { type: m[1], id: Number(m[2]) };
}

export function formatCardForDisplay(raw?: string | null): string | null {
  if (!raw) return null;
  const digits = String(raw).replace(/\D/g, '');
  if (!digits) return null;
  return digits.replace(/(\d{4})(?=\d)/g, '$1 ');
}

export function destinationAccountOptionLabel(b: BeneficiaryBankAccount): string {
  const card = formatCardForDisplay(b.card_number);
  if (card) return `${b.label} — کارت ${card}`;
  const sheba = b.sheba_number?.trim();
  if (sheba) return `${b.label} — ${sheba.toUpperCase()}`;
  return b.label;
}
